import { cloneDeep, defaultsDeep } from 'lodash'

import { DEFAULT_DOCUMENT_TEMPLATES_INVOICE_PAYLOAD, proxy } from '@/utils'

import render from './render'

export default {
  name: 'InvoiceDialog',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    show: Boolean,

    OwnerId: String,
    ResellerId: String
  },

  data() {
    return {
      formValidation: false
    }
  },

  computed: {
    validation() {
      const amount = this.proxy?.data?.SERVICE_PRICE || 0

      return (
        !!this.formValidation &&
        !!this.proxy.requisiteId &&
        !!this.proxy.companyId &&
        !!this.proxy.type &&
        !isNaN(amount) &&
        amount > 0
      )
    }
  },

  methods: {
    _inputFilter(data) {
      if (!data) {
        return cloneDeep(DEFAULT_DOCUMENT_TEMPLATES_INVOICE_PAYLOAD)
      }

      defaultsDeep(data, cloneDeep(DEFAULT_DOCUMENT_TEMPLATES_INVOICE_PAYLOAD))

      return data
    },

    close() {
      this.$emit('show', false)
      this.$emit('validation', this.validation)
    },
    submit(data) {
      this.$emit('input', data)
      this.close()
    }
  },

  render
}
